import {
  ActivityIcon,
  HeartIcon,
  HeartRangeMetricIcon,
  MeditationIcon,
  MoonIcon,
  WellnessIcon,
} from '@jouzen/ecom-components';
import type { SVGIconComponent } from 'types/svgr';

export interface Slide {
  button: {
    href: string;
  };
  category: string;
  id: number;
  image: {
    alt: string;
    src: string;
  };
  tag: {
    label: string;
    icon: SVGIconComponent;
  };
  title: string;
}

export const SLIDER_CONTENT: Slide[] = [
  {
    button: { href: 'https://ouraring.com/blog/category/sleep/' },
    category: 'sleep',
    id: 0,
    image: {
      alt: 'explore_image_alt_1',
      src: 'blue-sky/why-oura/sleep-rest',
    },
    tag: {
      label: 'sleep_rest_tag',
      icon: MoonIcon as SVGIconComponent,
    },
    title: 'best_sleep_of_life',
  },
  {
    button: { href: 'https://ouraring.com/blog/category/health/heart-health/' },
    category: 'heart_health',
    id: 1,
    image: {
      alt: 'explore_image_alt_2',
      src: 'blue-sky/why-oura/heart-health',
    },
    tag: {
      label: 'heart_health_tag',
      icon: HeartIcon as SVGIconComponent,
    },
    title: 'listen_to_heart',
  },
  {
    button: {
      href: 'https://ouraring.com/blog/category/health/activity-movement/',
    },
    category: 'activity',
    id: 2,
    image: {
      alt: 'explore_image_alt_3',
      src: 'blue-sky/why-oura/activity-fitness',
    },
    tag: {
      label: 'fitness_tag',
      icon: ActivityIcon as SVGIconComponent,
    },
    title: 'fitness_goals_focus',
  },
  {
    button: { href: 'https://ouraring.com/blog/category/health/' },
    category: 'wellness',
    id: 3,
    image: {
      alt: 'explore_image_alt_4',
      src: 'blue-sky/why-oura/wellness',
    },
    tag: {
      label: 'wellness_tag',
      icon: WellnessIcon as SVGIconComponent,
    },
    title: 'live_longer_healthier',
  },
  {
    button: {
      href: 'https://ouraring.com/blog/category/health/womens-health/',
    },
    category: 'womens_health',
    id: 4,
    image: {
      alt: 'explore_image_alt_5',
      src: 'blue-sky/why-oura/womens-health',
    },
    tag: {
      label: 'womens_health_tag',
      icon: HeartRangeMetricIcon as SVGIconComponent,
    },
    title: 'ins_outs_womens_health',
  },
  {
    button: {
      href: 'https://ouraring.com/blog/category/health/mental-health-stress/',
    },
    category: 'stress',
    id: 5,
    image: {
      alt: 'explore_image_alt_6',
      src: 'blue-sky/why-oura/stress',
    },
    tag: {
      label: 'stress_tag',
      icon: MeditationIcon as SVGIconComponent,
    },
    title: 'stress_to_test',
  },
];
